import React from "react";
import { Button } from "@arco-design/web-react";
import { IconLeft } from "@arco-design/web-react/icon";
import { useNavigate } from "react-router-dom";
import { reportBackUrl } from "../utils/reportBack";

// BackToReport shows when this page was opened from the Reports page, and goes
// back to it with the same filters. Otherwise it shows nothing.
export default function BackToReport() {
  const navigate = useNavigate();
  const back = reportBackUrl(window.location.search);
  if (!back) return null;
  return (
    <Button size="small" icon={<IconLeft />} style={{ marginBottom: 8 }} onClick={() => navigate(back)}>
      Back to report
    </Button>
  );
}
